module.exports = __webpack_public_path__ + "img/car_red.a6a228eb.png";